var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15 29.9998C6.7099 29.9998 0 23.2816 0 15C0 6.70967 6.70876 0 15 0C23.2903 0 29.9998 6.70876 29.9998 15C29.9998 23.2896 23.2809 29.9998 15 29.9998Z",
    fill: "#66A9DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15 0V29.9998C23.2809 29.9998 29.9998 23.2896 29.9998 15C29.9998 6.70898 23.2903 0 15 0Z",
    fill: "#4F84CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M15.0001 18.5156C10.6355 18.5156 6.474 20.4236 3.43262 24.549C9.48906 31.8697 20.6995 31.8073 26.6742 24.4183C25.1988 22.9507 21.8757 18.5156 15.0001 18.5156Z",
    fill: "#D6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M26.6741 24.4183C23.8534 27.9062 19.6211 29.9998 15 29.9998V18.5156C21.8758 18.5156 25.1987 22.9511 26.6741 24.4183Z",
    fill: "#BDECFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M15 15.8789C12.0921 15.8789 9.72656 13.5132 9.72656 10.6055V8.84766C9.72656 5.93994 12.0921 3.57422 15 3.57422C17.9077 3.57422 20.2734 5.93994 20.2734 8.84766V10.6055C20.2734 13.5132 17.9077 15.8789 15 15.8789Z",
    fill: "#D6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M15 3.57422V15.8789C17.9079 15.8789 20.2734 13.5134 20.2734 10.6055V8.84766C20.2734 5.93971 17.9079 3.57422 15 3.57422Z",
    fill: "#BDECFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.b43d664b3c697b054626298879cbd279.svg";
export { ForwardRef as ReactComponent };